import {defineStore} from 'pinia'
// import {client} from "@/libraries/http";


const useDpApplicationConstructionTime = defineStore('dp-application-construction-time', {
    state: () => ({
        startTime: null,
        endTime: null,
        limitedDuration: null,
    }),
    // getters: {
    //     getForm(state) {
    //         return state.form;
    //     },
    // },
    actions: {
        setStartTime(startTime) {
            this.startTime = startTime;
        },
        setEndTime(endTime) {
            this.endTime = endTime;
        },
        initLimit(limitedDuration) {
            this.limitedDuration = limitedDuration
        },
        reset() {
            this.startTime = null;
            this.endTime = null;
        }
    },
})

export default useDpApplicationConstructionTime;
